import { useState } from "react";
import classNames from "classnames";

function ImageFadeIn({ src, className, ...props }) {
  const [isLoaded, setIsLoaded] = useState(false);

  const revealImage = () => {
    setIsLoaded(true);
  };

  return (
    <img
      src={src}
      alt=""
      className={classNames("image-fade-in", isLoaded && "loaded", className)}
      onLoad={revealImage}
      {...props}
    />
  );
}

export default ImageFadeIn;
